import { useFormContext } from '@hooks/react-hook-form';
import { useActionLog } from '@hooks/use-action-log';

import ApplicationCard from '../../../../../application-card';

import ApplicationCamera from '../../application-camera';

import { IdentityPhotoProps } from './types';

const IdentityPhoto = (props: IdentityPhotoProps) => {
  const { readonly } = props;
  const {
    formState: { isSubmitting, isSubmitSuccessful },
  } = useFormContext();

  useActionLog({ page: 'upload_doc_page', view: !readonly });

  return (
    <ApplicationCard className='section-identity-photo'>
      <ApplicationCamera
        readonly={readonly}
        name='ktp'
        label='Foto KTP'
        cameraFacing='back'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
      <ApplicationCamera
        readonly={readonly}
        name='selfieKtp'
        label='Foto Selfie'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
    </ApplicationCard>
  );
};

export default IdentityPhoto;
